import { render, staticRenderFns } from "./NotAllowed.vue?vue&type=template&id=7389d8cc"
import script from "./NotAllowed.vue?vue&type=script&lang=js"
export * from "./NotAllowed.vue?vue&type=script&lang=js"
import style0 from "./NotAllowed.vue?vue&type=style&index=0&id=7389d8cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports